const DEPARTMENT_ROOT_PATH = "/settings/departments"
const DEPARTMENT_ADD_PATHNAME = `${DEPARTMENT_ROOT_PATH}/add`
const DEPARTMENT_EDIT_PATHNAME = `${DEPARTMENT_ROOT_PATH}/edit`

export const DEPARTMENT_PATHS = {
	root: DEPARTMENT_ROOT_PATH,
	add: DEPARTMENT_ADD_PATHNAME,
	edit: DEPARTMENT_EDIT_PATHNAME,
} as const
